import { render, staticRenderFns } from "./OrderListTableItem.vue?vue&type=template&id=04af8c1a&scoped=true&"
import script from "./OrderListTableItem.vue?vue&type=script&lang=js&"
export * from "./OrderListTableItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderListTableItem.vue?vue&type=style&index=0&id=04af8c1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af8c1a",
  null
  
)

export default component.exports